
<template>

    <section class="alumni-picker">
        <img src="../../static/img/software-img.jpg">
        <div class="text">
            <h2 class="text-center">Your Mentorship at Think Tank Online is over, now what?</h2>
            <p class="text-center">Now that you have wrapped up your Online Mentorship here are some things to think about and some resources to help you take the next steps.</p>
            <h3>Polish your work</h3>
            <p>Just because your mentorship is over doesn't mean your  portfolio development is done. In fact, you may find that nothing you have worked on thus far is impressive enough to get the attention of the industry you are targeting. The training you have received has given you the tools you need to work independently without the guidance of a mentor or instructor. With that in mind you must make sure your portfolio (demo reel) is at its highest level. In a word, it must be perfect, and more isn't always better. Recruiters will tell you, "hide the not so good stuff and show them only the gold.” So take the time after your mentorship ends and polish your reel and add new material that elevates your portfolio. If you don't know what “great” looks like, send your work to the Think Tank directors or your supervisor and get some feedback.</p>
            <h3>Your Mentor isn't dead</h3>
            <p>Nor are they gone.. A great mentor will want to see the end of the story. Which means they will want to see your progress and your final reel. Do what you can to keep the door open with them. Ask if you can continue to send updates from time to time. If they agree, which is likely, send an update every two weeks or so. In this industry networking is huge. It's sometimes not enough to be talented and hardworking. Getting someone to promote and recommend you can make all the difference. Your mentor can be a window to the inside.</p>
            <h3>Put yourself out there</h3>
            <p>To get attention from studios and recruiters, you must show your work and put yourself out there. We live in a new era where if your work isn’t available online, it just doesn’t exist. Find a platform that best suits your needs and go for it. Artstation is a great website that will help you get the attention you need in the beginning, but you can also use Facebook and Instagram.</p>
            <p>Make sure to start treating yourself as a brand, and like any other successful brand out there, you must have a place so people can appreciate your work.</p>
            <p>But only posting your final artwork sometimes isn’t enough to get enough attention, especially in such a competitive area. You must find your way to create original content that will attract attention from other artists and studios. Write about your process, create tutorials, articles, breakdowns, etc.</p>
            <p>Anything that you can do to contribute to the community will be seen as an active skill by your potential employer. Become a documentarian of what you do.</p>
            <p><a href="https://portal.tttc.ca/#/kb-article/20">Read More</a></p>
            <h3>Software</h3>
            <p>Software is not included in the alumni term but we can provide all your path’s software bundled at a fixed price. If you would like us to purchase this for you, for an additional term length (4 months), submit your choice below:</p>
        </div>

        <span class="need-software">Need Software?</span>

        <div class="checkboxes">

            <div class="form-group"><input class="checkbox" type="radio" v-model="needsSoftware" value="true" id="yes" name="needs_software"><label for="yes"><i class="fa fa-check-square-o"></i>Yes, invoice me $485 CAD</label></div>
            <div class="form-group"><input class="checkbox" type="radio" v-model="needsSoftware" value="false" id="no" name="needs_software"><label for="no"><i class="fa fa-check-square-o"></i>No, I don't need software</label></div>
            <div class="form-group text-right"><button class="btn btn-xs" @click.prevent="createInvoice()">Submit</button></div>
        </div>
    </section>  


</template>

<script>

import invoices from '../services/invoices';
import users from '../services/users';

import toastr from 'toastr';

export default {
    data() {
        return {
            needsSoftware: 'false',
        }
    },
    components: {

    },
    mounted() {
        this.getMe();
    },
    methods: {
        getMe() {
            var self = this;
            users.getMe(this).then(function(response) {
                if (response.data.person.alumniSoftwarePurchased === true) {
                    self.needsSoftware = 'true';
                }
            });
        },
        createInvoice() {
            if (this.needsSoftware === 'false') {
                toastr.info('If you change your mind, you have until 3 weeks before the next term starts to decide and pay');
                this.$router.push('/mentor-dashboard');
                return;
            }
            if (this.needsSoftware === 'true') {
                invoices.create(this, 'alumni-software').then(function(response) {
                    response.data.success === true ? toastr.success('Your invoice has been emailed to you, and will also appear under "My Tuition" within an hour.') : toastr.error(response.data.message);
                });
            }
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
    .text {
        h3 {
            font-size:16px;
        }
    }
    section {
        padding:2rem 1rem;
    }
    button {
        background:#676767;
        color:#fff;
        border:none;
    }
    .need-software {
        font-size: 32px;
        color:#fff;
        clear:both;
        width:100%;
        text-align:left;
        float:left;
        margin-top:2rem;
    }
    .checkboxes {
        border:1px solid #676767;
        padding:1rem 1rem 0;
        width:320px;
        margin-top:2rem;
        float:left;
        margin-bottom:3rem;
        label {
            position: relative;
            i {              
                margin-right:1rem;
                cursor:pointer;
            }
            .fa-square-o {
                font-size:2rem;
            }
            .fa-check {
                display:none;
                position: relative;
                left:-15px;
                top:-3px;
            }
        }
    }
    .checkbox {
        display:none;
        &:checked + label > i {
            color:#2DA21D;
        }
    }

</style>


// WEBPACK FOOTER //
// AlumniPicker.vue?f8bafd30